import React from "react";
import styled from "styled-components";
import { Icon, Typography, COLORS } from "@virkesborsen/ui-component-library";

const DFRProductCard = ({ property, area }) => (
  <PaperContainer>
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center gap-2">
        <DFRIcon>
          <Icon
            name="SatelliteSimple"
            size="large"
            color="spring-yellow-500"
          />
        </DFRIcon>
        <div className="d-flex flex-column gap-1">
          <Typography variant="labelMediumMediumDense">
            Skogsövervakning - 1 år (Avslutas automatiskt)
          </Typography>
          <Typography variant="labelMediumRegularDense" color="cloudy-900">
            {property?.designation ?? "-"}
          </Typography>
        </div>
      </div>
      <div>
        <Typography variant="labelMediumRegularDense" color="cloudy-900">
          {area ?? "-"} ha
        </Typography>
      </div>
    </div>
  </PaperContainer>
);

const DFRIcon = styled.div`
  width: 36px;
  height: 36px;
  background-color: ${COLORS["charcoal-500"]};
  border-radius: 8px;
  padding: 8px;
`;

const PaperContainer = styled.div`
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px solid #e6e6e8;
`;

export default DFRProductCard;
